import axios from '../axios';
// import router from '@/router/index';

export default {
  namespaced: true,
  state: () => ({
    logged_in: false,
    user_data: null
  }),
  actions: {
    async login({ dispatch }, payload) {
      try {
        const response = await axios.post('/auth/v2/login', payload);
        if(response.data.access_token) {
          localStorage.setItem('PERSONNEL_ACCESS_TOKEN', response.data.access_token); 
          dispatch('getSrruData');
        }
      } catch(error) {
        const { response } = error;
        throw(response.data);
      }
    },
    async getSrruData({ commit }) {
      try {
        const response = await axios.get('/user/srru_data');
        commit('SET_USER', response.data);
      } catch(error) {
        const { response } = error;
        throw(response.data);
      }
    },
    async logout({ commit }) {
      await axios.post('/auth/v2/logout');      
      localStorage.removeItem('PERSONNEL_ACCESS_TOKEN');
      commit('DESTROY_USER');
    },
    async identify({ dispatch }, citizen_id) {
      try {
        await axios.post('/user/identify', { citizen_id: citizen_id });
        dispatch('getSrruData');
      } catch (error) {
        const { response } = error;
        throw(response.data);
      }
    },
    destroyToken() {
      localStorage.removeItem('PERSONNEL_ACCESS_TOKEN');
      // commit('DESTROY_USER');
    }
  },
  mutations: {
    SET_BEARER (state, accessToken) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`
    },
    SET_USER(state, user_data) {
      state.logged_in = true;
      state.user_data = user_data;
    },
    DESTROY_USER(state) {
      state.logged_in = false;
      state.user_data = null;
    }
  }
    
}